
  import { Vue, Component, Prop } from "vue-property-decorator";

  import NotFoundPage from "@/components/common/NotFoundPage.vue";

  import { User } from "@/generated/graphql";

  @Component({
    components: {
      NotFoundPage,
    },
  })
  export default class UserRoleRouteGuard extends Vue {
    @Prop({ type: Object, required: true }) readonly currentUser!: User;

    get accessDenied(): boolean {
      //@ts-ignore
      const roles = this.$route.meta.roles;

      if (!roles) {
        return false;
      }

      const isAccessAllowed = roles.some((role: string) => role === this.currentUser.role);
      if (isAccessAllowed) {
        return false;
      }

      return true;
    }
  }
